class CustomNewsletterForm extends HTMLFormElement {
  constructor () {
    super()

    this.emailInput = null
    this.phoneInput = null
    this.phoneInstance = null
    this.successMessage = this.dataset.successMessage
    this.endpoint = 'https://bt-newsletter-form.by-association-only.workers.dev/signup'

    this.init()
  }

  init () {
    // Initialize after DOM is fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup())
    } else {
      this.setup()
    }
  }

  setup () {
    // Get form elements
    this.emailInput = this.querySelector('[data-custom-newsletter-form-el="email"]')
    this.phoneInput = this.querySelector('[data-custom-newsletter-form-el="phone"]')

    this.phoneFormattedInput = this.querySelector(
      '[data-custom-newsletter-form-el="phoneFormatted"]',
    )

    this.firstnameInput = this.querySelector('[data-custom-newsletter-form-el="firstname"]')
    this.lastnameInput = this.querySelector('[data-custom-newsletter-form-el="lastname"]')

    this.gdprInput = this.querySelector('[data-custom-newsletter-form-el="gdpr"]')

    if (this.phoneInput) {
      this.setupCountryCode = this.setupCountryCode.bind(this)

      document.addEventListener('DOMContentLoaded', () => this.setupCountryCode())

      this.phoneInput.addEventListener('countrychange', this.handlePhoneInput.bind(this))

      this.phoneInput.addEventListener('change', this.handlePhoneInput.bind(this))
    }
    // Add form submission handler
    this.addEventListener('submit', this.handleSubmit.bind(this))
  }

  setupCountryCode () {
    this.iti = window.intlTelInput(this.phoneInput, {
      utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
      separateDialCode: true,
      showFlags: false,
      initialCountry: 'auto',
      strictMode: true,
      async geoIpLookup (callback) {
        const response = await fetch('/browsing_context_suggestions.json')
        const json = await response.json()
        callback(json.detected_values.country.handle)
      },
    })
  }

  async handleSubmit (event) {
    event.preventDefault()

    try {
      const formData = this.getFormData()

      const response = await this.submitForm(formData)

      if (response.success) {
        this.showSuccess()
      } else {
        this.showError(`${response.error}` || 'Submission failed. Please try again.')
      }
    } catch (error) {
      console.error('Form submission error:', error)
      this.showError('An unexpected error occurred. Please try again later.')
    }
  }

  async handlePhoneInput () {
    if (this.phoneFormattedInput) {
      this.phoneFormattedInput.value = (await this.iti.getNumber()) || this.phoneInput.value
    }
  }

  showFieldError (field, message) {
    field.classList.add('error')

    let errorEl = field.nextElementSibling
    if (!errorEl || !errorEl.classList.contains('error-message')) {
      errorEl = document.createElement('div')
      errorEl.classList.add('error-message')
      field.parentNode.insertBefore(errorEl, field.nextSibling)
    }

    errorEl.textContent = message
  }

  getFormData () {
    const formData = {
      firstName: this.firstnameInput ? this.firstnameInput.value : '',
      lastName: this.lastnameInput ? this.lastnameInput.value : '',
      email: this.emailInput ? this.emailInput.value : '',
      phone:
        this.gdprInput && this.gdprInput.checked && this.phoneFormattedInput
          ? this.phoneFormattedInput.value
          : '',
      sms_consent: this.gdprInput ? this.gdprInput.checked : false,
      source: this.dataset.source,
      store: this.dataset.store,
    }

    return formData
  }

  async submitForm (data) {
    try {
      const response = await fetch(this.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })

      const responseData = await response.json()

      if (!response.ok) {
        console.error(`API Error: ${response.status}`, responseData)
      }

      return responseData
    } catch (error) {
      console.error('Fetch or JSON parsing failed:', error)
      return {
        success: false,
        message: 'Network error or invalid response from server.',
      }
    }
  }

  showSuccess () {
    this.reset()

    const successMessage = document.createElement('div')
    successMessage.classList.add('success-message')
    successMessage.textContent = this.successMessage || "You're signed up"

    this.innerHTML = ''
    this.appendChild(successMessage)
  }

  showError (message) {
    let errorContainer = this.querySelector('.form-error')
    if (!errorContainer) {
      errorContainer = document.createElement('div')
      errorContainer.classList.add('form-error')
      this.prepend(errorContainer)
    }

    errorContainer.textContent = message
    errorContainer.style.display = 'block'
  }
}

customElements.define('custom-newsletter-form', CustomNewsletterForm, {
  extends: 'form',
})
